import { useEffect, useState } from "react";
import { ClockIcon, UsersIcon } from "lucide-react";
const TOTAL_CUPOS = 200;
const CUPOS_RESTANTES = 37;
function pad(n: number) {
  return n.toString().padStart(2, "0");
}
export function CountdownUrgency() {
  const [seconds, setSeconds] = useState(() => {
    const saved = Number(sessionStorage.getItem("kit_countdown"));
    return saved && saved > 0 ? saved : 47 * 60 + 12; // ~47 min
  });
  useEffect(() => {
    const t = setInterval(() => {
      setSeconds(s => {
        const next = s > 0 ? s - 1 : 0;
        sessionStorage.setItem("kit_countdown", String(next));
        return next;
      });
    }, 1000);
    return () => clearInterval(t);
  }, []);
  const h = Math.floor(seconds / 3600);
  const m = Math.floor(seconds % 3600 / 60);
  const s = seconds % 60;
  const pct = Math.round(CUPOS_RESTANTES / TOTAL_CUPOS * 100);
  return <div className="rounded-2xl border border-red-100 bg-red-50/80 p-4 backdrop-blur" data-id="element-79" data-mp="1q633d3s2qwf">
      <div className="flex items-center justify-center gap-2 text-sm font-bold uppercase tracking-wide text-red-600" data-id="element-80" data-mp="2jr9xsx55q1lj">
        <ClockIcon size={16} data-id="element-81" data-mp="2opuyexobmnai" />
        <span data-id="element-82" data-mp="2or61swdutt13">La oferta termina en</span>
      </div>

      <div className="mt-3 flex items-center justify-center gap-2" data-id="element-83" data-mp="2ss81tffli944">
        {[{
        v: h,
        l: "Horas"
      }, {
        v: m,
        l: "Min."
      }, {
        v: s,
        l: "Seg."
      }].map((u, i) => <div key={u.l} className="flex items-center gap-2" data-id="element-84" data-mp="32i1buc03ag69" data-mpi={i}>
            <div className="flex min-w-[54px] flex-col items-center rounded-xl bg-blue-950 px-3 py-2 text-white" data-id="element-85" data-mp="32hj52lfswjk3">
              <span className="text-2xl font-extrabold tabular-nums" data-id="element-86" data-mp="37ip411021322">
                {pad(u.v)}
              </span>
              <span className="text-[10px] uppercase tracking-wide text-blue-200" data-id="element-87" data-mp="3ghaiajyhtvx1">
                {u.l}
              </span>
            </div>
            {i < 2 && <span className="text-xl font-bold text-blue-950" data-id="element-88" data-mp="1i40rmzrgrl41">:</span>}
          </div>)}
      </div>

      <div className="mt-4" data-id="element-89" data-mp="2pefbw2bwx29p">
        <div className="mb-1.5 flex items-center justify-between text-xs font-semibold text-blue-950" data-id="element-90" data-mp="2pdnfipahr0id">
          <span className="flex items-center gap-1" data-id="element-91" data-mp="2kgds1f6nwyx6">
            <UsersIcon size={14} className="text-blue-700" data-id="element-92" data-mp="2khov1csaa2n8" />
            Cupos restantes
          </span>
          <span className="text-red-600" data-id="element-93" data-mp="2udjh6hvpufur">
            {CUPOS_RESTANTES} de {TOTAL_CUPOS}
          </span>
        </div>
        <div className="h-3 w-full overflow-hidden rounded-full bg-blue-100" data-id="element-94" data-mp="38criphfcq024">
          <div className="h-full rounded-full bg-red-500 transition-all" style={{
          width: `${pct}%`
        }} data-id="element-95" data-mp="33e7xjj8l0sat" />
        </div>
        <p className="mt-1.5 text-center text-[11px] text-gray-500" data-id="element-96" data-mp="3i1t09c1jopi7">
          Últimas plazas disponibles a este precio
        </p>
      </div>
    </div>;
}